import React, { CSSProperties, FC } from 'react';
import { Space } from 'antd';
import { Formik } from 'formik';
import { Form, Input, SubmitButton } from 'formik-antd';
import { FormikOnSubmit } from 'lib/formik.utils';
import { SearchOutlined } from '@ant-design/icons/lib';
import styled from 'styled-components';
import { useFormatMessage } from 'common/hooks/useFormatMessage';
import { FormattedMessage } from 'react-intl';

const StyledSpace = styled(Space)`
  flex-wrap: wrap;
  > * {
    margin-bottom: 0.5rem;
    flex-grow: 1;
    flex-shrink: 1;
    max-width: 200px;
  }
`;

const StyledForm = styled(Form)`
  max-width: 100%;
`;

export interface BusinessPartnerFiltersFormModel {
  name?: string;
  identifier?: any;
}

export interface BusinessPartnerFiltersProps {
  loading?: boolean;
  value?: BusinessPartnerFiltersFormModel;
  onSubmit: FormikOnSubmit<BusinessPartnerFiltersFormModel>;
  style?: CSSProperties;
}

export const BusinessPartnerFilters: FC<BusinessPartnerFiltersProps> = ({
  onSubmit,
  loading,
  value = {},
  style,
}) => {
  const intlMessage = useFormatMessage();

  return (
    <Formik initialValues={value} onSubmit={onSubmit}>
      <StyledForm style={style} layout="inline">
        <StyledSpace>
          <Input
            name="name"
            placeholder={intlMessage({ id: 'name' })}
            style={{ minWidth: 150 }}
          />
          <Input
            name="uniqueNumber"
            placeholder={intlMessage({ id: 'identifier' })}
            style={{ minWidth: 150 }}
          />

          <Space>
            <SubmitButton
              type="default"
              loading={loading}
              icon={<SearchOutlined />}
            >
              <FormattedMessage id="search" />
            </SubmitButton>
          </Space>
        </StyledSpace>
      </StyledForm>
    </Formik>
  );
};
